<app-header-app xLink="/login"></app-header-app>
<app-form-template
  title="Új jelszó beállítása"
  [formGroup]="passwordForm"
  (submit)="setNewPassword()"
>
  <payee-password-form-field
    width="wide"
    formControlName="password"
  >
    <span payee-label>Új jelszó</span>
    @if (password.dirty) {
      <ng-container payee-error>
        @if (password.hasError("required")) {
          <mat-error>A mező kitöltése kötelező</mat-error>
        }
        @if (password.hasError("minlength")) {
          <mat-error>A jelszónak legalább 6 karakter hosszúnak kell lennie!</mat-error>
        }
      </ng-container>
    }
  </payee-password-form-field>

  <payee-password-form-field
    width="wide"
    formControlName="passwordConfirmation"
  >
    <span payee-label>Új jelszó megerősítése</span>
    @if (passwordConfirmation.dirty) {
      <ng-container payee-error>
        @if (passwordConfirmation.hasError("required")) {
          <mat-error>A mező kitöltése kötelező</mat-error>
        }
        @if (passwordConfirmation.hasError("passwordsDontMatch")) {
          <mat-error>A jelszavak nem egyeznek</mat-error>
        }
      </ng-container>
    }
  </payee-password-form-field>

  <button
    payee-button
    width="wide"
    [disabled]="loading()"
  >
    @if (!loading()) {
      Beállítás és mentés
    }
    @if (loading()) {
      <div class="bw-theme flex hcenter">
        <mat-progress-spinner
          color="accent"
          mode="indeterminate"
          diameter="30"
        ></mat-progress-spinner>
      </div>
    }
  </button>
</app-form-template>
